import React, {FC, useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const PegadaianSplashScreen: FC = () => {
  const navigate = useNavigate()
  return (
    <div
      className='container-xxl p-0 bg-white'
      style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}
    >

      <div className='row justify-content-center align-items-center mx-0 flex-grow-1'>

        <div className='col-12 col-md-8 col-lg-5 d-flex flex-column align-items-center justify-content-center py-15 px-10 bg-white'>
          <div className='mt-5 mb-10 w-100 d-flex justify-content-center'>
            <img
              src={toAbsoluteUrl('/img/icon-bus-besar.png')}
              alt='Bus Mudik'
              className='img-fluid'
              style={{maxWidth: '250px'}}
            />
          </div>

          {/* Brand Title */}
          <div className='text-center mb-12'>
            <h2
              className='fw-bolder mb-0 d-flex align-items-center justify-content-center flex-wrap'
              style={{
                fontSize: '30px', // Sedikit diperbesar agar lebih tegas
                gap: '10px', // Jarak otomatis antar elemen
                letterSpacing: '-0.5px',
              }}
            >
              <span style={{color: '#72BF44'}}>Mudik</span>
              <span style={{color: '#BFD730'}}>Bareng</span>
            </h2>
            <img
              src={toAbsoluteUrl('/img/pegadaian-logo-bl.png')}
              alt='pegadaian'
              style={{
                height: '50px',
                width: 'auto',
                objectFit: 'contain',
              }}
            />
          </div>

        
          <div className='mt-10 w-100 d-grid gap-4'>
            {/* Tombol Mulai (Daftar) */}
            <button
              onClick={() => navigate('/mudik-bersama/pegadaian/reservasi')}
              className='btn btn-success w-100 py-4 fw-bold shadow-sm'
              style={{
                backgroundColor: '#72BF44',
                borderRadius: '15px',
                fontSize: '16px',
                border: 'none'
              }}
            >
              Mulai Pendaftaran
            </button>

            {/* Tombol Check Booking (Outline) */}
            <button
              onClick={() => navigate('/mudik-bersama/pegadaian/check-booking')}
              className='btn w-100 py-4 fw-bold'
              style={{
                borderRadius: '15px',
                fontSize: '16px',
                color: '#72BF44',
                backgroundColor: 'transparent',
                border: '2px solid #72BF44'
              }}
            >
              Cek Status Booking
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PegadaianSplashScreen
